{
    "locale": "pt-PT",
    "General": {
        "OrText": "Ou",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Ir para My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Criar nova conta",
        "ButtonText_SignInToYourAccount": "Iniciar sessão na sua conta",
        "ButtonText_StartInterviewWithoutSigningUp": "Iniciar entrevista sem registo",
        "ButtonText_StartInterviewWithoutSigningIn": "Iniciar entrevista sem início de sessão",
        "Navlink_Dashboard": "Painel",
        "Navlink_MyInterviews": "As minhas entrevistas",
        "Navlink_LearnWithHubert": "Aprender com o Hubert",
        "Navlink_HelpCenter": "Centro de ajuda",
        "MyProfile": "O meu perfil",
        "LogOut": "Terminar sessão"
    },
    "Login": {
        "MainTitle": "Veja os resultados da sua entrevista Hubert",
        "Subtitle": "Inicie sessão para ver resultados, obter feedback, ler conselhos e muito mais.",
        "LoginTitle": "Inicie sessão na sua conta Hubert",
        "Label_Email": "E-mail",
        "Label_Password": "Palavra-passe",
        "ButtonText_SignIn": "Iniciar sessão",
        "ButtonText_ForgotPassword": "Esqueceu a palavra-passe?",
        "ButtonText_ContinueWithGoogle": "Continuar com Google",
        "OrSeparator": "Ou",
        "Error_Email_Required": "O e-mail é obrigatório.",
        "Error_Email_Invalid": "Introduza um e-mail válido.",
        "Error_Password_Required": "A palavra-passe é obrigatória.",
        "Error_Use_Same_Email_As_Interview": "Utilize o mesmo e-mail que forneceu na entrevista."
    },
    "Registration": {
        "MainTitle": "Veja os resultados da sua entrevista Hubert",
        "Subtitle": "Registe-se para ver resultados, obter feedback, ler conselhos e muito mais.",
        "RegistrationTitle": "Criar conta Hubert",
        "BenefitsBox_Title": "Pode",
        "BenefitsBox_Point1": "Aceder ao seu histórico de entrevistas",
        "BenefitsBox_Point2": "Obter feedback sobre as suas entrevistas",
        "BenefitsBox_Point3": "Reutilizar respostas em novas entrevistas",
        "BenefitsBox_Point4": "Obter conselhos de entrevista",
        "BenefitsBox_Point5": "Ler guias de carreira",
        "BenefitsBox_Point6": "E muito mais",
        "Label_FirstName": "Nome",
        "Label_LastName": "Apelido",
        "Label_Email": "E-mail",
        "Label_Password": "Palavra-passe",
        "Label_PhoneNumber": "Número de telefone",
        "Label_TermsOfService": "Aceito a",
        "Label_TermsOfServiceLink": "Política de Privacidade e os Termos e Condições",
        "Placeholder_CountryCode": "Selecione o código do país",
        "Placeholder_PhoneNumber": "Ex.912345678",
        "HelpText_Password": "A palavra-passe deve ter pelo menos 6 caracteres.",
        "ButtonText_SignUp": "Registar",
        "ButtonText_SignUpWithGoogle": "Registar com Google",
        "OrSeparator": "Ou",
        "Error_FirstName_Required": "O nome é obrigatório.",
        "Error_LastName_Required": "O apelido é obrigatório.",
        "Error_Email_Required": "O e-mail é obrigatório.",
        "Error_Email_Invalid": "Introduza um e-mail válido.",
        "Error_Email_Exists": "O e-mail já está a ser utilizado.",
        "Error_Password_Required": "A palavra-passe é obrigatória.",
        "Error_Password_6_Characters": "A palavra-passe deve ter pelo menos 6 caracteres.",
        "Error_PhoneNumber_Required": "O número de telefone é obrigatório.",
        "Error_PhoneNumber_Invalid": "O número de telefone não é válido.",
        "Error_PrivacyPolicyCheck_Required": "A Política de Privacidade e os Termos e Condições devem ser aceites."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "Para fazer a entrevista, aceite os termos e condições de utilização do Hubert. Basta marcar a caixa para continuar.",
        "Subtitle_AfterInterviewCompleted": "Registe-se para ver resultados, obter feedback, ler conselhos e muito mais.",
        "PrivacyPolicyText": "Ao premir registar concorda com a",
        "PrivacyPolicyLink": "Política de Privacidade e Termos e Condições",
        "ButtonText_SignUp": "Registar e ir para a entrevista",
        "ButtonText_SignUpNormal": "Registar",
        "ButtonText_SignInInstead": "Clique aqui para iniciar sessão"
    },
    "LoginInviteEmail": {
        "Subtitle": "Inicie sessão para ver resultados, obter feedback, ler conselhos e muito mais."
    },
    "AppMessages": {
        "internal-server-error": "Ocorreu um erro inesperado.",
        "invalid-credentials": "Credenciais inválidas. Tente novamente.",
        "user-not-found": "Credenciais inválidas. Tente novamente.",
        "account-not-found": "Conta inválida. Tente novamente.",
        "verify-email-title": "Verifique o seu e-mail",
        "verify-email-subtitle": "Verifique o seu e-mail para validar a sua conta.",
        "email-not-verified-title": "E-mail não verificado",
        "email-not-verified-subtitle": "Verifique o seu e-mail para validar a sua conta.",
        "verifying-email-title": "A verificar e-mail",
        "verifying-email-subtitle": "Aguarde...",
        "sign-in-title": "A iniciar sessão",
        "sign-in-subtitle": "Aguarde...",
        "server-error": "Algo correu mal.",
        "hubert-user-exists": "A conta já existe.",
        "account-exists": "A conta já existe.",
        "email-verified": "O seu e-mail foi verificado.",
        "email-is-taken": "O e-mail já está a ser utilizado.",
        "re-enter-password": "Use a sua palavra-passe para iniciar sessão",
        "password-reset": "A sua palavra-passe foi alterada.",
        "re-enter-new-password": "Use a sua nova palavra-passe para iniciar sessão",
        "invalid-invitation": "Convite inválido.",
        "invalid-code": "Código de verificação inválido.",
        "email-already-verified": "O e-mail já foi verificado.",
        "email-mismatch-title": "E-mail não corresponde",
        "email-mismatch-subtitle": "Utilize o mesmo endereço de e-mail que usou para se candidatar ao emprego."
    },
    "TransitionPage": {
        "loading-title": "A carregar...",
        "loading-subtitle": "A preparar os seus dados...",
        "logout-title": "A carregar...",
        "logout-subtitle": "A terminar sessão..."
    },
    "ImpersonationPage": {
        "loading-title": "A carregar...",
        "loading-subtitle": "A preparar os seus dados..."
    },
    "ProcessInvitation": {
        "loading-title": "A carregar...",
        "loading-subtitle": "Aguarde enquanto carregamos a sua entrevista.",
        "InvitationNotFound": "Não conseguimos encontrar a sua entrevista.",
        "InvitationExpired": "Esta ligação para aceder à entrevista expirou.",
        "InvitationExpired_Description1": "Abra a entrevista a partir de",
        "InvitationExpired_Description2": "ou contacte o seu recrutador.",
        "InvitationInvalid": "A ligação para este convite é inválida.",
        "InterviewCompleted": "Esta entrevista já foi concluída."
    },
    "Common": {
        "MyInterviews": {
            "Title": "As minhas entrevistas",
            "TableHead_Employer": "Empregador",
            "TableHead_Job": "Função",
            "TableHead_Status": "Estado",
            "TableHead_ApplicationDate": "Data da candidatura",
            "TableBody_StartInterview": "A entrevista não está concluída. Clique aqui para iniciar ou retomar.",
            "TableBody_NotScored": "A entrevista está concluída. Os resultados estarão disponíveis em breve.",
            "TableBody_Details": "Clique aqui para ver os resultados da entrevista e mais.",
            "ApplicationDate_Invited": "Convidado",
            "ApplicationDate_MinuteAgo": "minuto atrás",
            "ApplicationDate_MinutesAgo": "minutos atrás",
            "ApplicationDate_HourAgo": "hora atrás",
            "ApplicationDate_HoursAgo": "horas atrás",
            "ApplicationDate_DayAgo": "dia atrás",
            "ApplicationDate_DaysAgo": "dias atrás",
            "ButtonText_SeeAllInterviews": "Ver todas as entrevistas",
            "ButtonText_Details": "Detalhes",
            "ButtonText_StartInterview": "Ir para entrevista",
            "ButtonText_NotScored": "Resultados pendentes",
            "NoInterviews_Message": "Não há registos de entrevistas anteriores ou futuras para si."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Não há ofertas de emprego no momento. Verifique novamente mais tarde."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "A minha carreira",
            "Subtitle": "Selecione a entrevista para ver a avaliação e as suas perspetivas.",
            "MostRecentInterview": "Entrevista mais recente",
            "ToDo": "A fazer",
            "NoOngoingInterviews_Title": "Não tem novos convites para entrevistas.",
            "NoOngoingInterviews_Subtitle": "Novas entrevistas Hubert aparecerão aqui assim que forem agendadas pelos recrutadores.",
            "NoRecentInterviews_Title": "Não há registos de entrevistas anteriores.",
            "NoRecentInterviews_Subtitle": "Assim que for convidado para uma entrevista, ela aparecerá abaixo.",
            "ButtonText_StartInterview": "Ir para entrevista",
            "ButtonText_NotScored": "Resultados pendentes",
            "ButtonText_Details": "Detalhes"
        },
        "LearnWithHubert": {
            "Title": "Aprender com o Hubert",
            "Subtitle": "Obtenha conselhos sobre como melhorar em entrevistas e no trabalho.",
            "PickedForMe": "Últimos artigos",
            "ButtonText_SeeAllArticles": "Ver todos os artigos"
        },
        "HubertTip": {
            "Title": "Dica Hubert",
            "Subtitle": "Faça entrevistas mais rapidamente",
            "Description": "Está a candidatar-se a um novo emprego numa função semelhante à de uma entrevista Hubert anterior? Pode reutilizar as suas respostas e poupar tempo.",
            "ButtonText_ReadMoreTips": "Ler mais dicas"
        },
        "NewCandidateModalPopup": {
            "Title": "Tudo pronto!",
            "DescriptionLine1": "A sua conta está pronta.",
            "DescriptionLine2": "Faça a gestão das suas entrevistas e perfil. Veja resultados, obtenha feedback e aprenda mais sobre como fazer entrevistas.",
            "ButtonText_LetsGo": "Vamos lá"
        },
        "InterviewCompletedModal": {
            "Title": "Bom trabalho!",
            "Subtitle": "Concluiu a sua entrevista.",
            "Description": "Os recrutadores analisarão todas as candidaturas e fornecerão feedback por e-mail ou telefone assim que tiverem novidades.",
            "ButtonText_Continue": "Continuar"
        },
        "LatestJobPostings": {
            "Title": "Últimas ofertas de emprego",
            "Subtitle": "Explore outras ofertas de parceiros Hubert publicadas recentemente."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "As minhas entrevistas",
        "MyInterviewsSection_Subtitle": "Selecione a entrevista para ver a avaliação e as suas oportunidades de carreira.",
        "MyInterviewsSection_ToDo": "A fazer"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Ver todas as entrevistas",
        "InterviewNotFound_Title": "Acesso negado",
        "InterviewNotFound_Description": "Está a tentar aceder a detalhes de uma entrevista não associada à sua conta.",
        "ButtonText_GoToAllInterviews": "Ir para As minhas entrevistas",
        "InterviewDetails": {
            "Title": "Detalhes da entrevista",
            "ForRole": "Para a função",
            "InterviewCompletedOn": "Entrevista concluída a {{date}} às {{time}}"
        },
        "MyResult": {
            "Title": "O meu resultado",
            "Subtitle": "Correspondência avaliada",
            "ButtonText_LearnMore": "Ver como as suas respostas são avaliadas",
            "GotPotential_Title": "Bom potencial, falta um requisito",
            "GotPotential_Description": "As suas respostas indicam um forte potencial para este tipo de função. No entanto, com base nesta entrevista, pode não cumprir uma ou mais qualificações exigidas para este trabalho específico. Isso pode afetar os próximos passos, dependendo das necessidades do recrutador e do número de candidatos. Se não for convidado para a próxima fase, saiba que isso não reflete o seu potencial. Muitas vezes, trata-se de encontrar um ajuste preciso para as necessidades específicas da função. Veja as oportunidades e dicas abaixo.",
            "GotPotential_DescriptionSecondary": "A avaliação do Hubert é consultiva. O recrutador toma a decisão final e outros fatores, como o número de candidatos, também podem afetar o resultado.",
            "GreatMatch_Title": "Forte correspondência",
            "GreatMatch_Description": "As suas respostas alinharam-se bem com o que os recrutadores geralmente procuram nesta função, e cumpre os requisitos. Excelente trabalho. O recrutador analisará todos os candidatos e decidirá os próximos passos.",
            "GreatMatch_DescriptionSecondary": "A avaliação do Hubert é consultiva. O recrutador toma a decisão final e outros fatores, como o número de candidatos, também podem afetar o resultado. Se não for convidado para a próxima fase, saiba que isso não reflete o seu potencial. Muitas vezes, trata-se de encontrar um ajuste preciso para as necessidades específicas da função. Veja as oportunidades e dicas abaixo.",
            "OkMatch_Title": "Qualificado, aumente o impacto",
            "OkMatch_Description": "Cumpre os requisitos do trabalho. Para se destacar, as suas respostas podem beneficiar de mais clareza e especificidade. Reveja as suas respostas abaixo para ver onde a adição de um exemplo concreto ou resultado pode melhorar a sua pontuação.",
            "OkMatch_DescriptionSecondary": "A avaliação do Hubert é consultiva. O recrutador toma a decisão final e outros fatores, como o número de candidatos, também podem afetar o resultado.",
            "NotClearMatch_Title": "Pode não ser o ajuste certo agora",
            "NotClearMatch_Description": "Com base nesta entrevista, as suas respostas podem estar menos alinhadas com o que o recrutador procura, ou pode não cumprir um ou mais requisitos. Se quiser melhorar, comece pelas perguntas abaixo. Pequenas alterações, mais especificidade e resultados claros podem fazer uma grande diferença na próxima vez.",
            "NotClearMatch_DescriptionSecondary": "A avaliação do Hubert é consultiva. O recrutador toma a decisão final e outros fatores, como o número de candidatos, também podem afetar o resultado."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Experiências profissionais, motivações e competências",
            "QualifyingRequirements": "Requisitos de qualificação para este trabalho específico",
            "NotQualified_Title": "Áreas a melhorar",
            "NotQualified_Description": "As suas respostas podem ter sido menos específicas ou focadas em resultados do que o recrutador espera. Veja abaixo os locais destacados onde adicionar um exemplo concreto, ações que realizou ou um resultado claro pode fortalecer a sua resposta.",
            "GreatResults_Title": "Respostas fortes",
            "GreatResults_Description": "As suas respostas indicam que é um bom ajuste para este tipo de função e comunicou de forma clara. Se alguma pergunta puder ser melhorada, vê-la-á destacada abaixo.",
            "MeetingRequirements_Title": "Cumpre os requisitos",
            "MeetingRequirements_Description": "As suas respostas indicam que cumpre os requisitos de qualificação definidos pelo recrutador para este trabalho. Boa base.",
            "NotAllExpectationsMet_Title": "Um ou mais requisitos em falta",
            "NotAllExpectationsMet_Description": "Com base nas suas respostas, pode não cumprir um ou mais requisitos de qualificação para este trabalho específico, como certificados, licenças, nível de educação ou anos de experiência.",
            "ButtonText_FindOutPossibleReasons": "Ver detalhes"
        },
        "ScriptFromInterview": {
            "Title": "Ler a sua entrevista completa",
            "ButtonText_SeeWholeTranscript": "Ler entrevista",
            "ButtonText_DeleteInterview": "Eliminar entrevista",
            "Loading_Title": "A carregar...",
            "Loading_Subtitle": "Aguarde enquanto carregamos a transcrição da sua entrevista."
        },
        "HowToImproveAtInterviews": {
            "Title": "Como melhorar em entrevistas",
            "Subtitle_Questions": "Aqui estão algumas perguntas onde a sua resposta poderia potencialmente ser melhorada.",
            "Subtitle_NoQuestions": "Não foram sinalizadas respostas específicas. Aqui estão as melhores formas de adicionar impacto para esta função.",
            "GreatMatch_Questions_Description": "Mesmo com uma forte correspondência, algumas respostas podem ser reforçadas. Se identificámos alguma, encontrá-la-á abaixo. Siga as instruções antes de cada pergunta. Ao descrever uma situação, inclua a situação, o que fez e o resultado. Evite respostas muito curtas. Tente descrições claras e concretas, como faria numa entrevista presencial.",
            "GreatMatch_NoQuestions_Description": "Provavelmente saiu-se bem em todas ou na maioria das perguntas. Bom trabalho.",
            "OkMatch_Questions_Description": "Abaixo encontrará perguntas onde a sua resposta poderia ser melhorada. Siga as instruções antes de cada pergunta. Ao descrever uma situação, inclua a situação, o que fez e o resultado. Evite respostas muito curtas. Tente descrições claras e concretas, como faria numa entrevista presencial.",
            "OkMatch_NoQuestions_Description": "As suas respostas foram sólidas, mas esta função pode ser competitiva. Isso significa que mesmo boas respostas podem ficar na média.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Da próxima vez, tente clareza e impacto. Comece com o resultado, adicione um exemplo real e mantenha a concisão, geralmente 3 a 6 frases. Seja específico sobre o que fez, como fez e o que mudou devido a isso.",
            "GotPotential_Questions_Description": "Mesmo que pareça um forte candidato para este tipo de trabalho, algumas respostas podem ser reforçadas. Se identificámos alguma, encontrá-la-á abaixo. Siga as instruções antes de cada pergunta. Ao descrever uma situação, inclua a situação, o que fez e o resultado. Evite respostas muito curtas. Tente descrições claras e concretas, como faria numa entrevista presencial.",
            "GotPotential_NoQuestions_Description": "Não encontrámos respostas que precisem de grandes melhorias em termos de competências profissionais e motivações. Parece ter respondido bem a esses tópicos.",
            "NotClearMatch_Questions_Description": "Abaixo encontrará perguntas onde a sua resposta poderia ser melhorada. Siga as instruções antes de cada pergunta. Ao descrever uma situação, inclua a situação, o que fez e o resultado. Evite respostas muito curtas. Tente descrições claras e concretas, como faria numa entrevista presencial.",
            "NotClearMatch_NoQuestions_Description": "Não encontrámos uma única resposta “má”. É mais sobre o alinhamento geral com as necessidades da função. Se a concorrência for forte, pequenas lacunas podem importar.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "Para a próxima entrevista, foque na concretização. Escolha um exemplo por pergunta, explique as suas ações e partilhe o resultado. Curto e específico geralmente vence longo e geral.",
            "Alert_WantMoreAdvice": "Quer mais conselhos sobre como ter um bom desempenho numa entrevista Hubert?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Explore o nosso artigo de conselhos gerais"
        },
        "SimilarOffers": {
            "Title": "Ofertas semelhantes"
        },
        "HowHubertScoresInterviews": {
            "Title": "Como o Hubert avalia as entrevistas?",
            "Description": "Abaixo está uma breve descrição de como o Hubert avalia as respostas. Adicionámos também uma secção, Processo de Recrutamento, para explicar os próximos passos.",
            "Tabs_PossibleOutcomes": "Resultados possíveis",
            "Tabs_RecruitmentProcess": "Processo de recrutamento",
            "AssessedMatch_Title": "Correspondência avaliada",
            "AssessedMatch_Description": "O Hubert avalia como as suas respostas se alinham globalmente com o que os recrutadores procuram. Juntamente com os requisitos da função, verá um dos resultados abaixo.",
            "AssessedMatch_DescriptionSecondary": "A avaliação do Hubert é consultiva. O recrutador toma a decisão final e outros fatores, como o número de candidatos, também podem afetar o resultado.",
            "GreatMatch_Title": "Forte correspondência",
            "GreatMatch_Description": "As suas respostas alinharam-se bem com o que os recrutadores procuram, e cumpre os requisitos. Excelente trabalho. O recrutador analisará os candidatos e decidirá os próximos passos.",
            "GotPotential_Title": "Bom potencial, falta um requisito",
            "GotPotential_Description": "As suas respostas indicam um forte potencial. No entanto, pode não cumprir uma ou mais qualificações exigidas. Isso pode afetar os próximos passos, dependendo das necessidades do recrutador.",
            "OkMatch_Title": "Qualificado, aumente o impacto",
            "OkMatch_Description": "Cumpre os requisitos. Para se destacar, as suas respostas podem precisar de mais clareza e especificidade. Use o feedback para fortalecer os seus exemplos no futuro.",
            "NotClearMatch_Title": "Pode não ser o ajuste certo agora",
            "NotClearMatch_Description": "Com base nesta entrevista, as suas respostas podem estar menos alinhadas com o que o recrutador procura, e pode não cumprir alguns requisitos. Reveja as suas respostas para ver onde pode adicionar clareza e exemplos.",
            "ProfessionalExperiences_Title": "Experiências profissionais, motivações e competências",
            "ProfessionalExperiences_Description": "Estas são perguntas sobre as suas experiências anteriores, motivação e competências relevantes. Os recrutadores decidem quais as perguntas usadas.",
            "GreatResults_Title": "Respostas fortes",
            "GreatResults_Description": "As suas respostas indicam que é um bom ajuste para esta função e comunicou de forma clara. Se alguma pergunta puder ser melhorada, vê-la-á destacada.",
            "NotQualified_Title": "Áreas a melhorar",
            "NotQualified_Description": "As suas respostas podem ter sido menos específicas ou focadas em resultados. Procure locais destacados onde adicionar um exemplo concreto ou resultado claro pode fortalecer as suas respostas.",
            "QualifyingRequirements_Title": "Requisitos básicos ou de qualificação",
            "QualifyingRequirements_Description": "Estas são perguntas definidas como requisitos de qualificação, por exemplo, um certificado necessário, carta de condução ou nível de experiência.",
            "MeetingRequirements_Title": "Cumpre os requisitos",
            "MeetingRequirements_Description": "As suas respostas indicam que cumpre os requisitos de qualificação definidos pelo recrutador. Boa base.",
            "NotAllExpectationsMet_Title": "Um ou mais requisitos em falta",
            "NotAllExpectationsMet_Description": "Com base nas suas respostas, pode não cumprir um ou mais requisitos de qualificação para este trabalho específico.",
            "RecruitmentProcess_Title": "Processo de recrutamento",
            "RecruitmentProcess_Description": "O Hubert é tipicamente usado como o primeiro passo num processo de recrutamento com muitos candidatos. Permite que todos façam uma entrevista e partilhem mais sobre si. Como as perguntas são as mesmas para todos, o processo é mais consistente. O Hubert não usa informações como idade, género ou aparência, reduzindo o risco de viés inconsciente.",
            "EventOne_Title": "É entrevistado pelo Hubert",
            "EventOne_Description": "Faz a entrevista quando e onde lhe for mais conveniente. Não há restrições de tempo e pode fazer uma pausa a qualquer momento.",
            "EventTwo_Title": "A sua entrevista é avaliada",
            "EventTwo_Description": "O Hubert avalia as suas respostas usando tecnologia moderna. Assim que a avaliação estiver concluída, os resultados são visíveis aqui no My Hubert e para o recrutador.",
            "EventThree_Title": "O recrutador seleciona candidatos",
            "EventThree_Description": "Os recrutadores veem quando um novo resultado está disponível no sistema deles. Podem rever as suas respostas e a avaliação do Hubert. Com base nisso, decidem os próximos passos. Se outros candidatos forem um melhor ajuste, a sua candidatura pode não avançar para a próxima fase.",
            "ButtonText_Close": "Fechar"
        }
    },
    "MyProfile": {
        "Title": "O meu perfil",
        "MyDetails": {
            "Title": "Os meus detalhes",
            "Label_FirstName": "Nome",
            "Label_LastName": "Apelido",
            "Label_Email": "E-mail",
            "Label_PhoneNumber": "Número de telefone",
            "ButtonText_UpdateDetails": "Atualizar detalhes",
            "Error_FirstName_Required": "O nome é obrigatório.",
            "Error_LastName_Required": "O apelido é obrigatório.",
            "Error_Email_Required": "O e-mail é obrigatório.",
            "Error_Email_Invalid": "Introduza um e-mail válido.",
            "Error_PhoneNumber_Invalid": "O número de telefone não é válido.",
            "Success_Details_Updated": "Perfil atualizado."
        },
        "ChangePassword": {
            "Title": "Alterar palavra-passe",
            "Set_Password_Title": "Criar palavra-passe",
            "Label_CurrentPassword": "Palavra-passe atual",
            "Label_NewPassword": "Nova palavra-passe",
            "Label_RepeatNewPassword": "Repetir nova palavra-passe",
            "Alert_SignInAgain": "Inicie sessão novamente para definir a sua palavra-passe.",
            "ButtonText_UpdatePassword": "Atualizar palavra-passe",
            "ButtonText_SetPassword": "Definir palavra-passe",
            "ButtonText_SignInAgain": "Iniciar sessão novamente",
            "Error_CurrentPassword_Required": "A palavra-passe atual é obrigatória.",
            "Error_CurrentPassword_DoesntMatch": "A palavra-passe não corresponde à atual.",
            "Error_NewPassword_Required": "A nova palavra-passe é obrigatória.",
            "Error_NewPassword_6_Characters": "A nova palavra-passe deve ter pelo menos 6 caracteres.",
            "Error_RepeatNewPassword_Required": "A repetição da palavra-passe é obrigatória.",
            "Error_RepeatNewPassword_DoesntMatch": "A palavra-passe não corresponde à nova.",
            "Success_Password_Changed": "Palavra-passe atualizada.",
            "Error_Invalid_CurrentPassword": "Palavra-passe atual inválida."
        },
        "NotificationPreferences": {
            "Title": "Preferências de notificação",
            "Label_ReceiveUpdatesToggle": "Quero receber atualizações do Hubert.",
            "Label_ReceiveUpdatesToggleHelpText": "Receberá guias de carreira, dicas de entrevista e mais."
        },
        "AccountRemoval": {
            "Title": "Remoção de conta",
            "ButtonText_RemoveMyAccount": "Remover a minha conta"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Olá",
        "Subtitle": "Está prestes a iniciar a sua entrevista de emprego.",
        "TipBox_Title": "Aqui estão algumas dicas para ajudar.",
        "TipBox_Tip1": "Faça a entrevista num local calmo para se concentrar.",
        "TipBox_Tip2": "Responda num computador com teclado, se possível.",
        "TipBox_Tip3": "Seja o mais específico e detalhado possível. O Hubert e os recrutadores querem conhecê-lo bem.",
        "TipBox_Tip4": "Aproveite o tempo que precisar. Não há limite de tempo.",
        "TipBox_Tip5": "Pode fazer uma pausa e continuar de onde parou.",
        "TipBox_Tip6": "Seja você mesmo e empenhe-se como numa entrevista real.",
        "CheckAdviceArticle_Text1": "Se quiser mais dicas sobre como ter sucesso na entrevista, veja este",
        "CheckAdviceArticle_Text2": "artigo",
        "CheckAdviceArticle_Text3": "com ótimos conselhos.",
        "ReadyToGetStarted": "Pronto para começar?",
        "ORSeparator_Text": "Ou",
        "ButtonText_StartInterviewNow": "Iniciar entrevista agora",
        "ButtonText_SetReminder": "Não estou pronto, definir lembrete",
        "PrivacyPolicyText": "Ao premir iniciar entrevista concorda com a",
        "PrivacyPolicyLink": "Política de Privacidade e Termos e Condições"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Bom trabalho!",
        "CompletedAlert_Subtitle": "Concluiu a sua entrevista.",
        "CompletedAlert_Description": "Os recrutadores analisarão todas as candidaturas e fornecerão feedback assim que tiverem novidades.",
        "InterviewNotCompleted": "Esta entrevista não está concluída."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Centro de ajuda",
            "Subtitle": "Encontre as respostas para as perguntas mais frequentes sobre o Hubert.",
            "Label_Search": "pesquisar perguntas frequentes",
            "ButtonText_Search": "Pesquisar"
        },
        "FAQSection": {
            "Tabs_All": "Tudo",
            "Tabs_AboutHubertInterview": "Sobre a entrevista Hubert",
            "Tabs_TechnicalSupport": "Suporte técnico"
        },
        "StillHaveQuestion": {
            "Title": "Ainda tem dúvidas?",
            "Description": "Estamos felizes em ajudar.",
            "DropUsAEmail": "Envie-nos um e-mail para hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Posso fazer a entrevista por telefone?",
                    "a": "O Hubert funciona apenas por chat. Se tiver uma condição médica que impeça, contacte a empresa."
                },
                {
                    "q": "Posso fazer a entrevista noutra língua?",
                    "a": "Em algumas entrevistas pode escolher a língua. Se não houver opção, a língua é provavelmente um requisito. Contacte a empresa."
                },
                {
                    "q": "Serei penalizado por respostas curtas?",
                    "a": "Não, desde que responda adequadamente. Mas detalhes ajudam."
                },
                {
                    "q": "Posso reutilizar respostas?",
                    "a": "Sim, se estiver no My Hubert e se candidatar a uma função semelhante."
                },
                {
                    "q": "Um humano vai ler a minha entrevista?",
                    "a": "Sim, os nossos clientes verificam manualmente as entrevistas."
                },
                {
                    "q": "Fiz a entrevista, e agora?",
                    "a": "Os resultados são enviados ao recrutador. Eles decidem o próximo passo (chamada, teste, entrevista final)."
                },
                {
                    "q": "Tenho uma pergunta sobre os próximos passos, quem devo contactar?",
                    "a": "Contacte a empresa onde se candidatou."
                },
                {
                    "q": "Como evitam o viés no recrutamento?",
                    "a": "O Hubert é consistente e não sabe idade, género ou aparência, reduzindo o viés."
                },
                {
                    "q": "Posso ser entrevistado por um humano?",
                    "a": "Contacte a empresa para perguntar sobre isso."
                },
                {
                    "q": "O Hubert é humano?",
                    "a": "Não, é um sistema informático."
                },
                {
                    "q": "Posso mudar as respostas depois?",
                    "a": "Não, tal como numa entrevista real, não pode refazer."
                },
                {
                    "q": "Como ter sucesso na entrevista?",
                    "a": "Leia atentamente, siga as instruções, dê exemplos reais e seja honesto."
                },
                {
                    "q": "Preciso de um emprego, quem devo contactar?",
                    "a": "Contacte a empresa onde se candidatou."
                },
                {
                    "q": "Fiz a entrevista mas não ouvi nada. O que devo fazer?",
                    "a": "Os recrutadores decidem os próximos passos. Se outros candidatos forem melhores, podem recusar. Pode contactar o recrutador."
                },
                {
                    "q": "Tenho experiência mas não consegui o emprego. Porquê?",
                    "a": "Muitas vezes é uma questão de ajuste às necessidades específicas da função e de comparação com outros candidatos, não um juízo sobre o seu valor. Se possível, peça à empresa uma breve explicação. No My Hubert pode rever as suas respostas e ver sugestões do que tornar mais claro ou mais concreto da próxima vez."
                },
                {
                    "q": "Quanto tempo demora a entrevista?",
                    "a": "Entre 10 e 25 minutos. Não se apresse."
                },
                {
                    "q": "Onde posso ler sobre o tratamento de dados?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Porque não vejo as minhas entrevistas anteriores?",
                    "a": "Certifique-se de que usou o mesmo e-mail na candidatura e no login do My Hubert (incluindo Google login)."
                },
                {
                    "q": "Porque não recebi um e-mail?",
                    "a": "Verifique o spam. Ou crie uma conta My Hubert com o e-mail da candidatura para encontrar a ligação."
                },
                {
                    "q": "Não encontro a ligação no e-mail.",
                    "a": "Verifique o spam. Ou entre no My Hubert e vá a 'As minhas entrevistas' para encontrar a ligação."
                },
                {
                    "q": "Funciona em telemóveis?",
                    "a": "Sim! Mas um computador pode ser mais confortável para escrever."
                },
                {
                    "q": "A entrevista não funciona, o que fazer?",
                    "a": "Envie um e-mail para hubert@hubert.ai."
                },
                {
                    "q": "Quero eliminar a minha conta, o que fazer?",
                    "a": "Envie um e-mail para hubert@hubert.ai."
                },
                {
                    "q": "A entrevista foi interrompida, como voltar?",
                    "a": "Clique na ligação do e-mail ou entre no My Hubert."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Aprender com o Hubert",
            "Subtitle": "Descubra como aumentar as suas hipóteses e ter um melhor desempenho.",
            "Label_Search": "pesquisar guias",
            "ButtonText_Search": "Pesquisar"
        },
        "TabSelector": {
            "MyFeed": "O meu feed",
            "InterviewGuides": "Guias de entrevista",
            "CareerGuides": "Guias de carreira"
        },
        "NewestOnTheFeed": "Mais recentes",
        "PickedForMe": "Últimos artigos",
        "InterviewGuides": "Guias de entrevista",
        "CareerGuides": "Guias de carreira"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Voltar a todos os artigos"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Redefinir palavra-passe",
        "ResetLinkAlert_Subtitle": "Clique na ligação enviada para o seu e-mail para definir uma nova palavra-passe.",
        "PasswordNotSetAlert_Message": "Palavra-passe não definida, inicie sessão com",
        "ResetYourPassword": {
            "MainTitle": "Veja os resultados da sua entrevista Hubert",
            "Subtitle": "Inicie sessão para ver resultados, obter feedback e muito mais.",
            "FormSectionTitle": "Redefinir palavra-passe",
            "Label_NewPassword": "Nova palavra-passe",
            "Label_ConfirmNewPassword": "Confirmar nova palavra-passe",
            "Error_NewPassword_Required": "Introduza uma nova palavra-passe.",
            "Error_Password_6_Characters": "A nova palavra-passe deve ter pelo menos 6 caracteres.",
            "Error_ConfirmNewPassword_Required": "Deve confirmar a nova palavra-passe.",
            "Error_ConfirmNewPassword_NotMatch": "A palavra-passe não corresponde.",
            "Error_MalformedResetUrl": "Código de segurança inválido. Tente novamente.",
            "Error_ResetPasswordFailed": "Problema ao redefinir. Tente novamente.",
            "Error_WeakPassword": "A palavra-passe deve ter pelo menos 6 caracteres.",
            "Error_InvalidCode_Title": "O pedido expirou ou é inválido.",
            "Error_InvalidCode_Subtitle": "Tente redefinir a sua palavra-passe novamente.",
            "ButtonText_SetNewPassword": "Definir e iniciar sessão",
            "ButtonText_RememberYourPassword": "Lembra-se da palavra-passe?",
            "ButtonText_SignInInstead": "Iniciar sessão"
        }
    },
    "PageNotFound": {
        "Title": "Página não encontrada",
        "Description": "Não conseguimos encontrar a página que procura.",
        "ButtonText_GoToDashboard": "Ir para Painel",
        "ButtonText_GoToLogin": "Ir para Login"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "A reutilização de respostas ainda não está disponível para esta entrevista. Esperamos que esteja em breve, mas pode fazer a entrevista agora.",
        "DescriptionLine2": "Prossiga para a entrevista clicando no botão abaixo.",
        "ButtonText_TakeMeToTheInterview": "Leve-me para a entrevista"
    },
    "UnsubscribeFromEmails": {
        "Title": "Tem a certeza?",
        "Subtitle": "Deixará de receber e-mails sobre este trabalho:",
        "SelectTheReason": "Selecione um motivo.",
        "ReasonText1": "Encontrei outro emprego.",
        "ReasonText2": "Já não estou interessado.",
        "ReasonText3": "Outro",
        "ButtonText_Unsubscribe": "Cancelar subscrição",
        "Placeholder_YourReason": "O seu motivo",
        "Success_Title": "Cancelou a subscrição com sucesso.",
        "Loading": "A carregar...",
        "Error_YourReason_Required": "Introduza o motivo.",
        "Error_ServerIssue": "Falha ao cancelar subscrição devido a erro no servidor."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Tentar novamente"
    },
    "Outreach": {
        "CandidateNotFound": "Candidato não encontrado",
        "CandidateNotFoundDesc": "Não conseguimos encontrar os detalhes da entrevista que procura.",
        "InterviewEnded": "Entrevista terminada",
        "InterviewEndedDesc1": "Esta sessão de entrevista terminou ou já não está disponível.",
        "InterviewEndedDesc2": "Obrigado pelo seu tempo. Se tiver alguma dúvida, contacte a equipa de recrutamento.",
        "ReadyTitle": "Está pronto para a sua entrevista, {{firstName}}?",
        "InvitationDesc": "O Hubert, em nome da {{companyName}}, convida-o para uma entrevista por chat que demora aproximadamente 1-2 minutos a concluir.",
        "Button_StartChat": "Iniciar entrevista por chat",
        "CancelNotice": "Iniciar aqui cancelará a chamada agendada para esta função.",
        "PreferNotToContinue": "Prefere não continuar?",
        "DeclineLabel": "Não estou interessado nesta função. Não me ligue nem me envie mensagens novamente sobre esta posição.",
        "Button_ConfirmAndDecline": "Confirmar e recusar",
        "Processing": "A processar...",
        "Toast_DeclineSuccess": "Entrevista recusada com sucesso",
        "Toast_CancelVoiceInfo": "Entrevista por voz cancelada. Funcionalidade disponível em breve.",
        "Toast_CancelError": "Falha ao cancelar a entrevista. Por favor, tente novamente.",
        "Footer_WithdrawConsent": "Pode retirar o seu consentimento a qualquer momento. Saiba mais na ",
        "Footer_PrivacyPolicySuffix": "política de privacidade da ",
        "Footer_And": " e na ",
        "Footer_HubertPrivacyLink": "política de privacidade e termos e condições do Hubert",
        "Chat_InterviewWith": "Entrevista com {{companyName}}",
        "Chat_StatusConnected": "Ligado",
        "Chat_StatusError": "Erro",
        "Chat_StatusDisconnected": "Desligado",
        "Chat_StatusConnecting": "A ligar...",
        "Chat_ReadyToStart": "Pronto para iniciar a entrevista?",
        "Chat_ButtonStart": "Iniciar entrevista",
        "Chat_SayHello": "Diga olá para iniciar a conversa.",
        "Chat_EmptyState": "Envie uma mensagem para iniciar a entrevista.",
        "Chat_SelectLanguage": "Selecione o seu idioma",
        "Chat_Placeholder": "Escreva a sua mensagem...",
        "Chat_ButtonSend": "Enviar",
        "Chat_ButtonBack": "Voltar",
        "LoadingCandidateDetails": "A carregar detalhes do candidato...",
        "FetchingCandidateDetails": "A obter detalhes do candidato...",
        "Chat_StatusReady": "A aguardar ligação...",
        "Chat_ForbiddenError": "Esta entrevista por chat já não está disponível.",
        "Chat_GeneralError": "Falha ao iniciar o chat. Por favor, tente novamente mais tarde.",
        "Chat_SelectUiLanguage": "Idioma do menu",
        "Chat_InterviewTitle": "Entrevista de emprego"
    }
}
